import { render, staticRenderFns } from "./r-discovery-mode.vue?vue&type=template&id=383bafb5"
import script from "./r-discovery-mode.vue?vue&type=script&lang=js"
export * from "./r-discovery-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383bafb5')) {
      api.createRecord('383bafb5', component.options)
    } else {
      api.reload('383bafb5', component.options)
    }
    module.hot.accept("./r-discovery-mode.vue?vue&type=template&id=383bafb5", function () {
      api.rerender('383bafb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/discovery/r-discovery-mode.vue"
export default component.exports